export default "/_next/static/assets/images/formio-placeholder-mobile.65ffa60e292ddb959329493d3f796e34.png";